// Shared shell for every Section (Firm / CRM / Insurance / Marketing).
// Renders a sub-nav bar with NavLinks for each sub-route and an Outlet
// where the route's content goes.
//
// Usage in a section component:
//   <SectionLayout
//     title="Firm"
//     items={[
//       { to: '/firm', label: 'Dashboard', end: true },
//       { to: '/firm/pl', label: 'P&L View' },
//       ...
//     ]}
//   >
//     {/* Anything common to all routes in this section, optional */}
//   </SectionLayout>

import { NavLink, Outlet } from 'react-router-dom';

export default function SectionLayout({ title, items = [], actions, children }) {
  return (
    <div className="space-y-4">
      {/* Section sub-nav */}
      <div className="bg-white rounded-[4px] shadow-[0_2px_6px_rgba(0,0,0,0.07)] px-4 py-2 flex items-center gap-1 overflow-x-auto">
        {title && (
          <span className="text-[10px] font-bold uppercase tracking-[0.12em] text-[#aaa] mr-3 shrink-0">
            {title}
          </span>
        )}
        {items.map(item => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.end}
            className={({ isActive }) =>
              `px-3 py-1.5 text-[12px] font-bold rounded-[3px] transition-colors whitespace-nowrap ${
                isActive
                  ? 'bg-bullogic-blue text-white'
                  : 'text-[#666] hover:text-navy hover:bg-bone'
              }`
            }
          >
            {item.label}
          </NavLink>
        ))}
        {/* Right-aligned slot for section-level actions (e.g., "+ Upload") */}
        {actions && <div className="ml-auto flex items-center gap-2 shrink-0">{actions}</div>}
      </div>

      {/* Optional content shown above all sub-routes */}
      {children}

      {/* Sub-route content */}
      <Outlet />
    </div>
  );
}
